import axios from 'axios';
import { Module } from '../types/module';
import { API_CONFIG } from '../config/apiConfig';

export const moduleService = {
  getAllModules: async (): Promise<Module[]> => {
    const response = await axios.get(`${API_CONFIG.BASE_URL}/Module/GetAllModules`);
    return response.data;
  },

  getModuleById: async (id: string): Promise<Module> => {
    const response = await axios.get(`${API_CONFIG.BASE_URL}/Module/${id}`);
    return response.data;
  },

  saveModule: async (module: Partial<Module>): Promise<Module> => {
    const response = await axios.post(`${API_CONFIG.BASE_URL}/Module/SaveModule`, module);
    return response.data;
  },

  uploadFile: async (file: File, onProgress?: (progress: number) => void): Promise<{ url: string }> => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      const formData = new FormData();
      formData.append('file', file);

      xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable && onProgress) {
          const progress = Math.round((event.loaded / event.total) * 100);
          onProgress(progress);
        }
      });

      xhr.addEventListener('load', () => {
        if (xhr.status === 200) {
          try {
            const response = JSON.parse(xhr.responseText);
            resolve(response);
          } catch (error) {
            reject(new Error('Invalid response format'));
          }
        } else {
          reject(new Error('Failed to upload file'));
        }
      });

      xhr.addEventListener('error', () => {
        reject(new Error('Network error'));
      });

      xhr.open('POST', `${API_CONFIG.BASE_URL}/FileUpload/Upload`);
      xhr.send(formData);
    });
  }
}; 